import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'order-bar',
  templateUrl: './order-bar.component.html',
  styleUrls: ['./order-bar.component.scss']
})
export class OrderBarComponent {

  @Input() discoverFilter: any;
  @Output() eventOrderDiscoverList: EventEmitter<any> = new EventEmitter<any>();

  onOrderBy(field) {
    this.eventOrderDiscoverList.emit(field);
  }

  hasOrderBy(orderField) {
    if (!this.discoverFilter.orderBy) {
      return false;
    }
    return this.discoverFilter.orderBy === orderField;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/discover/order-bar/order-bar.component.ts